export default __webpack_public_path__ + "static/media/erp_w_bg.a1ff0351.png";